<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-18 15:10:17
 * @LastEditors: geory
 * @LastEditTime: 2025-10-11 15:28:45
-->
<template>
  <div
    class="dialogCover"
    :style="{ width: pageWidth + 'px', height: pageHeight + 'px' }"
    @click="dialogCoverClick"
  >
    <div class="dialogMain">
      <div class="dialogMainTitle">话术移动至</div>
      <div class="dialogMainContent">
        <div class="dialogMainContentL">选择分类</div>
        <el-select
          v-model="value"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="btnBar">
        <div
          class="btnBarL"
          @click="cancel"
        >
          取消
        </div>
        <div
          class="btnBarR"
          @click="save"
        >
          保存
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import Vue from "vue";
Vue.use(Select);
Vue.use(Option);
export default {
  props: {
    typeList: {
      type: Array,
      default: () => [],
    },
  },
  name: "ChangeHuashuTypeDialog",
  data() {
    return {
      pageWidth: document.documentElement.clientWidth,
      pageHeight: document.documentElement.clientHeight,
      options: this.typeList.map((type) => {
        let labelName = type.labelName.substring(0, 10);
        if (type.labelName.length > 10) {
          labelName += "...";
        }
        return {
          value: type.labelId,
          label: labelName,
        };
      }),
      value: "",
    };
  },
  mounted() {
    console.log("typeList:", this.typeList);
  },
  methods: {
    save() {
      if (!this.value) {
        return;
      }
      this.$emit("save", this.value);
    },
    cancel() {
      this.$emit("cancel");
    },
    dialogCoverClick() {},
  },
};
</script>

<style>
.el-popper {
  z-index: 99999 !important;
}
</style>

<style scoped>
.dialogCover {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.dialogMain {
  width: 582px;
  height: 187px;
  background-color: #fff;
  border-radius: 4px;
}

.dialogMainTitle {
  font-size: 18px;
  color: #303133;
  padding: 15px;
}

.dialogMainContent {
  display: flex;
  align-items: center;
}

.dialogMainContentL {
  font-size: 14px;
  color: #303133;
  padding: 15px;
  margin-right: 15px;
}

.btnBar {
  display: flex;
  align-items: center;
  justify-content: end;
  margin-top: 15px;
}

.btnBarL {
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  margin-right: 15px;
}

.btnBarR {
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fd365d;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  color: #ffffff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  margin-right: 15px;
}
</style>
